import { Button } from '@backstage/ui';
import { Icon } from '@iconify/react';
import { SolutionEntityFilter } from '@ipen-portal/ipen-entity-model';
import { useGetEntitiesByFilter } from '@ipen-portal/plugin-common-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useShuffledEntities } from '../../../hooks/useShuffledEntities';
import { HomeEntityCard } from '../components/HomeEntityCard';
import { SolutionsHomeCardFilter } from './components/SolutionsHomeCardFilter';

export const SolutionsHomeCard = () => {
  const { data, isError, isPending } = useGetEntitiesByFilter(SolutionEntityFilter);
  const solutions = useShuffledEntities(data);
  const navigate = useNavigate();
  const [selectedTag, setSelectedTag] = useState<null | string>(null);
  const filteredSolutions = selectedTag === null
    ? solutions
    : solutions.filter(solution => solution.metadata.tags?.includes(selectedTag));
  const emptyMessage = selectedTag === null ? 'No solutions available.' : 'No solutions match this tag.';
  const message = isError
    ? 'Solutions could not be loaded.'
    : !isPending && !filteredSolutions.length ? emptyMessage : undefined;

  return (
    <HomeEntityCard
      aria-label="Solutions"
      entities={filteredSolutions}
      footerAction={(
        <Button
          aria-label="Go to Marketplace"
          onPress={() => navigate('/solution-marketplace')}
          variant="primary"
        >
          <Icon aria-hidden="true" icon="ri:arrow-right-s-line" />
          Go to Marketplace
        </Button>
      )}
      headerActions={(
        <SolutionsHomeCardFilter
          onFilterChange={setSelectedTag}
          solutions={solutions}
          value={selectedTag}
        />
      )}
      key={selectedTag === null ? 'all' : `tag:${selectedTag}`}
      loading={isPending}
      message={message}
      showImages
      title="Looking for a Solution?"
    />
  );
};
